import {DOCUMENT} from '@angular/common';
import {Component, Inject, Input, OnInit, Renderer2} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {EMPTY, Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {Page} from '../../content/models/page';
import {KontentService} from '../../content/service';

@Component({
	selector: 'app-page',
	templateUrl: './page.component.html',
	styleUrls: ['./page.component.less']
})
export class PageComponent implements OnInit {
	@Input() kontentCodename: string;

	linkedItems;
	page$: Observable<Page> = EMPTY;

	constructor(
		private kontentService: KontentService,
		public domSanitizer: DomSanitizer,
		private renderer2: Renderer2,
		@Inject(DOCUMENT) private _document,
	) {
	}

	ngOnInit() {
		this.page$ = this.kontentService.deliveryClient
			.item<Page>(this.kontentCodename)
			.depthParameter(2)
			.toObservable().pipe(
				tap(t => {
					this.linkedItems = t.linkedItems;
					console.log('Linked Items:', this.linkedItems);

					const brightcoveExperienceIDs = Object.keys(this.linkedItems).map(i => this.linkedItems[i]).map(i => i.brightcove_experience_id).filter(i => i).map(i => i.value);
					console.log('Experience IDs:', brightcoveExperienceIDs);

					for (const bcExperienceID of brightcoveExperienceIDs) {
						const s = this.renderer2.createElement('script');
						s.type = 'text/javascript';
						s.src = 'https://players.brightcove.net/4828955589001/experience_' + bcExperienceID + '/live.js';
						s.text = ``;
						this.renderer2.appendChild(this._document.body, s);
					}
				}),
				map(i => i.item),
				tap(t => {
					console.log('Loaded page:', t);
				}),
			);
	}

	getBrightcoveVideoIframeSrc(videoId) {
		// console.log('Brightcove Video ID:', videoId);
		return this.domSanitizer.bypassSecurityTrustResourceUrl(
			`https://players.brightcove.net/4828955589001/default_default/index.html?videoId=${videoId}`
		);
	}

	parseVideoIDIntoSrc(videoID) {
		let parsedID: SafeResourceUrl;
		if (videoID.includes('/')) {
			if (videoID.includes('showcase')) {
				parsedID = this.domSanitizer.bypassSecurityTrustResourceUrl('https://vimeo.com/' + videoID + '/embed');
			} else {
				parsedID = this.domSanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/' + videoID.split('/')[0] + '?h=' + videoID.split('/')[1]);
			}
		} else {
			parsedID = this.domSanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/' + videoID);
		}
		return parsedID;
	}
}
